// Store locator ZIP hand-off.
//
// The hero's store finder submits to the locator page as ?zip=62034. Storemapper
// exposes no URL-parameter or search API — its documented surface is only the
// storemapper_callback / after_search callbacks and Storemapper.map — so the
// only way in is to drive its own search box: set the value, then click its
// Search button (#storemapper-zip / #storemapper-go). The widget reads the
// input's value at click time, so no synthetic input events are needed —
// firing them would only open Google's autocomplete list over the results.
//
// The catch: #storemapper-go exists in the DOM before Storemapper binds its
// click handler, and window.Storemapper is already an object by then too, so
// neither is a usable readiness signal. Clicking in that window sets the field
// but runs no search — which is exactly the "ZIP is in the box but I still have
// to press enter" symptom. So we don't trust a single click: after each one we
// check whether the search actually took and retry until it does.
//
// Storemapper.prevQuery is the signal — it stays "" while the handler is
// unbound and becomes the query once the search really runs.
//
// The param name must match the hero section's "ZIP query parameter" setting;
// it is read from this script tag's data-zip-param attribute.
(function () {
  const script =
    document.currentScript || document.querySelector('script[data-zip-param]');
  const paramName =
    (script && script.getAttribute('data-zip-param')) || 'zip';

  let zip;
  try {
    zip = new URLSearchParams(window.location.search).get(paramName);
  } catch (e) {
    return;
  }
  zip = (zip || '').trim();

  // Every other page view stops here — one query-string read, no DOM work.
  if (!zip) return;

  const POLL_MS = 150;
  const READY_TIMEOUT_MS = 20000;
  const RETRY_MS = 400;
  const MAX_ATTEMPTS = 15;

  let waited = 0;

  function searchApplied() {
    const sm = window.Storemapper;
    return !!(sm && String(sm.prevQuery || '').trim() === zip);
  }

  function attempt(n, input, button) {
    if (searchApplied()) return;
    if (n >= MAX_ATTEMPTS) return;

    // Back off the moment the shopper takes over the field, so a late retry
    // can't overwrite what they are typing.
    if (document.activeElement === input) return;
    if (input.value && input.value !== zip) return;

    input.value = zip;
    button.click();
    // Don't leave the field focused; on mobile that would raise the keyboard
    // over the results the shopper just asked for.
    input.blur();

    setTimeout(function () {
      attempt(n + 1, input, button);
    }, RETRY_MS);
  }

  function start() {
    const input = document.getElementById('storemapper-zip');
    const button = document.getElementById('storemapper-go');

    // The widget is injected by a third-party script, so wait for it rather
    // than assuming it has booted. Give up quietly if it never appears — the
    // shopper still has a working locator, just without the ZIP filled in.
    if (!input || !button) {
      waited += POLL_MS;
      if (waited < READY_TIMEOUT_MS) setTimeout(start, POLL_MS);
      return;
    }

    attempt(0, input, button);
  }

  start();
})();
